interface Ga {
  clientId: null | string
}

export const ga: Ga = reactive({
  clientId: computed(() => cookies._ga || null),
})
